import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'
import ScrollArea from 'react-scrollbar'

import {FeaturedProducts} from './featured_products.component'

import {BookingItemBlock} from '../widgets/layout/bookingitemblock.component'

export class Booking extends React.Component {
    constructor(props) {
        super(props)
        console.log(props)

        this.state = {
            formSuccess: false,
            errorMessage: null
        }

        _.bindAll(this,
            'getOrigin',
            'getReturn',
            'submitBookingRequest',
            'getSidebarContent'
        )
    }

    submitBookingRequest() {
        let self = this

        axios.post('/api/v1/trips/' + this.props.tripGuid + '/itinerary/' + this.props.itinGuid + '/quote/', {
            notes: document.getElementById('notes').value
        }).then(function (response) {
            if (response.data !== undefined) {
                // TODO: Fade out sidebar content and show success message
                console.log(response)
                self.setState({formSuccess: true})
            } else {
                console.log('ERROR: in submitBookingRequest error')
                console.log(response)
                self.setState({errorMessage: response.data})
            }
        }).catch(function (err) {
            console.log('ERROR: in submitBookingRequest error')
            console.log(err)
            self.setState({errorMessage: 'Error submitting request'})
        })
    }

    getOrigin() {
        if (this.props.originDestination) {
            let origin = 'Origin: ' + this.props.originDestination.getIn(['destination', 'title'])
            let originTravel = this.props.allTransportation.filter((transportation) => {
                if (this.props.originDestination && transportation.getIn(['legDep']) === this.props.originDestination.get('id')) {
                    return true
                } else {
                    return false
                }
            })
            let originTravelOptions = originTravel.map((travel, index) => {
                return (
                    <div key={travel.getIn(['transportation', 'transportation_guid'])} className="booking-list-item">
                        <div className="booking-list-item-header">
                            <h3>
                                <i className="icon-plane_right"/> {travel.getIn(['transportation', 'name'])}
                            </h3>
                        </div>
                        <div className="booking-list-item-tools hidden">
                            <i className="icon-filters"/>
                            <i className="icon-reservation"/>
                            <i className="icon-chat"/>
                            <i className="icon-diamond"/>
                        </div>
                        <div className="booking-list-item-status hidden">
                            <i className="icon-complete"/>
                        </div>
                    </div>
                )
            })

            return (
                <div className="booking-leg booking-origin">
                    <div className="booking-leg-header">
                        <h2>{ origin }</h2>
                    </div>
                    <div className="booking-list-items">
                        { originTravelOptions }
                    </div>
                </div>
            )
        } else {
            return null
        }
    }

    getReturn() {
        if (this.props.returnDestination) {
            let returnDest = 'Return: ' + this.props.returnDestination.getIn(['destination', 'title'])
            let returnTravel = this.props.allTransportation.filter((transportation) => {
                if (this.props.returnDestination && transportation.getIn(['legArr']) === this.props.returnDestination.get('id')) {
                    return true
                } else {
                    return false
                }
            })
            let returnTravelOptions = returnTravel.map((travel, index) => {
                return (
                    <div key={travel.getIn(['transportation', 'transportation_guid'])} className="booking-list-item">
                        <div className="booking-list-item-header">
                            <h3>
                                <i className="icon-plane"/> {travel.getIn(['transportation', 'name'])}
                            </h3>
                        </div>
                        <div className="booking-list-item-tools hidden">
                            <i className="icon-filters"/>
                            <i className="icon-reservation"/>
                            <i className="icon-chat"/>
                            <i className="icon-diamond"/>
                        </div>
                        <div className="booking-list-item-status hidden">
                            <i className="icon-complete"/>
                        </div>
                    </div>
                )
            })

            return (
                <div className="booking-leg booking-return">
                    <div className="booking-leg-header">
                        <h2>{ returnDest }</h2>
                    </div>
                    <div className="booking-list-items">
                        { returnTravelOptions }
                    </div>
                </div>
            )
        } else {
            return null
        }
    }

    getSidebarContent() {
        if (this.state.formSuccess) {
            return (
                <div id="booking-sidebar">
                    <div className="booking-sidebar-quote">
                        <a className="booking-close btn btn-white" onClick={() => this.props.onToggleBooking() }>Back to
                            Planner<i className="icon-arrow_right_b"/></a>
                        <h1>Thank you!</h1>
                        <p>
                            You should receive a confirmation email of your request and a Luna representative will
                            follow up with you.
                        </p>
                        <p>
                            If you have any questions or would like to contact us directly, please email <a
                            href="mailto:help@lunamoon.com">help@lunamoons.com</a>
                        </p>
                    </div>
                </div>
            )
        } else {
            let travelers = this.props.travelers.map((traveler, index) => {
                return (<div key={ index }>{traveler.get('firstname')} {traveler.get('lastname')}</div>)
            })

            let tripDates = ''
            if (this.props.properties.get('arrivalDate') != '') {
                let startDate = moment(this.props.properties.get('arrivalDate')).format('dddd, MMMM Do YYYY')
                let endDate = moment(this.props.properties.get('departureDate')).format('dddd, MMMM Do YYYY')
                tripDates = (
                    <div>
                        <h2>Dates</h2>
                        Departure: {startDate}<br/>
                        Return: {endDate}
                    </div>
                )
            }

            return (
                <div id="booking-sidebar">
                    <div className="booking-sidebar-info">
                        <a className="booking-close btn btn-white" onClick={() => this.props.onToggleBooking() }>Back to
                            Planner<i className="icon-arrow_right_b"/></a>
                        <h2>Travelers</h2>
                        {travelers}
                        {tripDates}
                    </div>
                    <div className="booking-sidebar-quote">
                        <h2>Additional Requests/Notes</h2>
                        <p>Please include any special requests, questions, or additional thoughts in the text box below.
                            A Luna Planner will respond to your inquiry within 24 hours. </p>
                        <div className="form-group text-area">
                            <textarea name="notes" className="form-control input-medium" id="notes"/>
                            <span className="error red">{ this.state.errorMessage }</span>
                            <br/>
                        </div>
                        <div className="form-group">
                            <button
                                type="submit"
                                onClick={() => {
                                    this.submitBookingRequest()
                                }}
                                className="btn btn-white btn-large">
                                Request Quote
                            </button>
                        </div>
                    </div>
                </div>
            )
        }
    }

    getActivities(activities) {
        if (activities.size > 0) {
            // Order activities by Date/Time in the reservation details (return -1, 0, or 1)
            let sortedItems = activities.sort(
                (a, b) => {
                    let aDate = a.getIn(['reservation_details', 'reservation_date']) ? moment(a.getIn(['reservation_details', 'reservation_date'])) : null
                    let aTime = a.getIn(['reservation_details', 'reservation_time']) ? moment(a.getIn(['reservation_details', 'reservation_time'])) : null
                    let bDate = b.getIn(['reservation_details', 'reservation_date']) ? moment(b.getIn(['reservation_details', 'reservation_date'])) : null
                    let bTime = b.getIn(['reservation_details', 'reservation_time']) ? moment(b.getIn(['reservation_details', 'reservation_time'])) : null
                    // check a vs b
                    if (aDate) {
                        // we have a date, does b have a date?
                        if (bDate) {
                            // both have dates
                            if (aDate < bDate) {
                                return -1 // move a up the list
                            } else if (aDate > bDate) {
                                return 1 // move a down the list
                            } else {
                                // same day, do we have a time?
                                if (aTime || bTime) {
                                    // we have at least one time
                                    if (aTime && bTime) {
                                        // we have two times
                                        if (aTime < bTime) {
                                            return -1 // a is earlier
                                        } else if (aTime > bTime) {
                                            return 1 // a is later
                                        } else {
                                            return 0 // same time?
                                        }
                                    } else if (aTime) {
                                        // we only have one time, if it's a move it up, else move it down
                                        return -1
                                    } else {
                                        return 1
                                    }
                                } else {
                                    return 0 // leave it alone
                                }
                            }
                        } else {
                            // b does not have a date, move a up the list
                            return -1
                        }
                    } else {
                        return 1 // no date, push to end of list
                    }
                }
            )

            let prevDayBreak = null
            let newDayBreak = null
            let activityItems = sortedItems.map((act, index) => {
                let dayBreak = null
                if (act.getIn(['reservation_details', 'reservation_date'])) {
                    newDayBreak = moment(act.getIn(['reservation_details', 'reservation_date'])).format('MMM Do')
                    if (newDayBreak !== prevDayBreak) {
                        prevDayBreak = newDayBreak
                        dayBreak = <div className="booking-day-label">{prevDayBreak}</div>
                    }
                } else {
                    newDayBreak = 'Dates Not Set'
                    if (newDayBreak !== prevDayBreak) {
                        prevDayBreak = newDayBreak
                        dayBreak = <div className="booking-day-label">{prevDayBreak}</div>
                    }
                }
                return (
                    <div key={act.get('activity_guid')}>
                        {dayBreak}
                        <BookingItemBlock item={act}/>
                    </div>
                )
            })
            return (<div><span>Activities</span>{activityItems}</div>)
        } else {
            return null
        }
    }

    getAccommodations(accoms) {
        if (accoms.size > 0) {
            let helperText = ''
            if (accoms.size > 1) {
                helperText = <span className="helper-text">We see you have multiple hotels on this leg.</span>
            }
            let accommItems = accoms.map((acc, index) => {
                return (
                    <BookingItemBlock key={acc.get('accommodation_guid')} item={acc}/>
                )
            })
            return (<div><span>Accommodations</span>{helperText}{accommItems}</div>)
        } else {
            return null
        }
    }

    getByLeg() {
        let eachLeg = this.props.legs.map((leg, index) => {
            let accoms = this.getAccommodations(leg.get('accommodations'))
            let activities = this.getActivities(leg.get('activities'))
            let days = (Math.ceil(leg.getIn(['properties', 'end'])) - Math.floor(leg.getIn(['properties', 'start']))) + ' Days'
            let nights = Math.floor(leg.getIn(['properties', 'end']) - leg.getIn(['properties', 'start'])) + ' Nights'

            let legDates = ''
            if (this.props.properties.get('arrivalDate') != '') {
                let startDate = moment(this.props.properties.get('arrivalDate')).add(Math.floor(leg.getIn(['properties', 'start'])), 'd').format('MMM Do')
                let endDate = moment(this.props.properties.get('arrivalDate')).add(Math.floor(leg.getIn(['properties', 'start']) + Math.floor(leg.getIn(['properties', 'length']))), 'd').format('MMM Do')
                legDates = (
                    <span>: {startDate} - {endDate}</span>
                )
            }
            return (
                <div key={index} className="booking-leg">
                    <div className="booking-leg-header">
                        <h2>Destination {index + 1}: {leg.getIn(['destination', 'title'])}</h2>
                        <span>{days}/{nights} {legDates}</span>
                    </div>
                    <div className="booking-list-items">
                        {accoms}
                        {activities}
                    </div>
                </div>
            )
        })

        return (
            <div className="booking-legs-container">
                { this.getOrigin() }
                {eachLeg}
                { this.getReturn() }
            </div>
        )
    }

    render() {
        if (window._isMobile) {
            // no scroller
            return (
                <div id="booking-overview">
                    <div className="booking-header">
                        <h1 dangerouslySetInnerHTML={{__html: this.props.properties.get('tripTitle')}}/>
                        <p>This quote reflects the trip items from your itinerary. The prices listed are best estimates.
                            You can refine the estimate by reviewing each section of the quote, or have Luna complete
                            the details for you.
                            <br/>Please note that some items require extra time to confirm availability and total price.
                        </p>
                    </div>
                    <div className="booking-body">
                        { this.getByLeg() }
                    </div>
                    <FeaturedProducts lunaTrip={this.props.lunaTrip}/>
                    { this.getSidebarContent() }
                </div>
            )
        } else {
            return (
                <div id="booking-overview">
                    <ScrollArea ref="scrollArea" speed={0.8} className="area" contentClassName="booking-scroll-area" horizontal={false}>
                        <div className="booking-header">
                            <h1 dangerouslySetInnerHTML={{__html: this.props.properties.get('tripTitle')}}/>
                            <p>This quote reflects the trip items from your itinerary. The prices listed are best
                                estimates. You can refine the estimate by reviewing each section of the quote, or have
                                Luna complete the details for you.
                                <br/>Please note that some items require extra time to confirm availability and total
                                price.</p>
                        </div>
                        <div className="booking-body">
                            { this.getByLeg() }
                        </div>
                    </ScrollArea>
                    <FeaturedProducts lunaTrip={this.props.lunaTrip}/>
                    { this.getSidebarContent() }
                </div>
            )
        }
    }
}